import { useState } from "react";
import { IconButton, Dialog } from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import QRCodeScanner from "components/qrCodeScanner/QRCodeScanner";

type Props = {
    setValue: (data: string) => void;
};

const ScanQRCodeButton = ({ setValue }: Props) => {
    const [open, setOpen] = useState(false);

    const handleScan = (data: string) => {
        setValue(data);
        setOpen(false);
    };

    return (
        <>
            <IconButton
                onClick={() => setOpen(true)}
                disableRipple
                disableFocusRipple
            >
                <QrCodeScannerIcon />
            </IconButton>

            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >
                <QRCodeScanner
                    onScanSuccess={handleScan}
                    onClose={() => setOpen(false)}
                />
            </Dialog>
        </>
    );
};

export default ScanQRCodeButton;
